/**
 * @fileoverview CSRFトークン発行API
 *
 * このファイルでは、クロスサイトリクエストフォージェリ(CSRF)対策のための
 * トークンをバックエンドAPIから取得する機能を提供します。
 */

/**
 * CSRFトークンを発行する
 *
 * バックエンドAPIにリクエストを送信し、新しいCSRFトークンを取得します。
 * このトークンは、フォーム送信などの状態を変更する操作において、
 * CSRF攻撃からアプリケーションを保護するために使用されます。
 *
 * @returns {Promise<string>} 新たに発行されたCSRFトークンを含むPromise
 * @throws {Error} API通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

type CsrfTokenResponseType = { csrf_token: string };

export const issueCsrfToken = async () => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;
  const issueCsrfTokenUrl = `${bffOrigin}/v1/csrf`;

  const res = await fetchWithLog(issueCsrfTokenUrl, {
    method: "POST",
    cache: "no-cache",
    credentials: "include",
  });

  if (!res.ok) {
    console.error("Failed to issue CSRF token.");
    throw new Error("Failed to issue CSRF token.");
  }

  const csrfTokenResponse = (await res.json()) as CsrfTokenResponseType;

  return csrfTokenResponse.csrf_token;
};
